module.exports = __webpack_public_path__ + "img/Group 3007.668cfc6e.svg";